<i18n lang="yaml" locale="en">
  only one asset error: Too many assets selected.
  replace file: Replace file
</i18n>

<i18n lang="yaml" locale="de">
  only one asset error: Zu viele Dateien ausgewählt.
  replace file: Datei ersetzen
</i18n>

<template>
  <div
    v-if="$parent.isInProject"
    class="editor file-editor"
  >
    <dropzone
      v-if="$localeMode"
      :target="$parent"
      :validation-fn="validateDrag"
      @drop="onDrop"
    >
      {{ $t('replace file') }}
    </dropzone>
    <span
      v-if="!$localeMode"
      class="remove"
    >
      <delete
        @click.native.stop="$parent.$store.dispatch('remove')"
        class="icon"
        color="black"
        size="xs"
      />
    </span>
    <span
      class="settings"
      :class="{'locale-mode': $localeMode}"
    >
      <settings
        @click="handleEdit"
        class="icon"
        color="black"
        size="xs"
      />
    </span>
    <span
      v-if="!$localeMode"
      class="move-handle"
      draggable
    >
      <move
        class="icon"
        color="black"
        size="xs"
      />
    </span>
  </div>
  <div
    v-else
    :class="{'file-editor': true, 'asset-editor': true}"
    draggable
    v-draggable="$store.getters.path"
    @click="toggleSelected"
  >
    <span class="asset-editor-settings">
      <settings
        @click.native.stop="handleEdit"
        class="icon"
        color="white"
        size="xs"
      />
    </span>
    <span
      class="asset-editor-remove"
    >
      <delete
        @click.native.stop="removeAsset"
        class="icon"
        color="danger"
        size="xs"
      />
    </span>
  </div>
</template>

<script>
import Delete from '@/components/icons/Delete'
import Move from '@/components/icons/Move'
import Settings from '@/components/icons/Settings'
import draggable from '@/directives/draggable'
import Dropzone from '@/components/editor/Dropzone'
import { Error } from '@/plugins/snotify'

export default {
  name: 'FileEditor',
  components: {
    Delete,
    Move,
    Settings,
    Dropzone
  },
  directives: {
    draggable
  },
  inheritAttrs: false,
  computed: {
    iconColor () {
      return this.$parent.isInProject ? 'black' : 'white'
    },
    $localeMode () {
      return this.$parent.$localeMode
    }
  },
  methods: {
    handleEdit () {
      this.$router.replace({ query: { edit: this.$store.getters.path } })
    },
    toggleSelected () {
      this.$root.$store.dispatch('toggleAssetSelected', {
        path: this.$store.getters.path
      })
    },
    removeAsset () {
      if (this.$root.$store.getters.isAssetSelected(this.$parent.$store.getters.path)) {
        this.$root.$store.dispatch('toggleAssetSelected', {
          path: this.$parent.$store.getters.path
        })
      }
      this.$parent.$store.dispatch('remove')
    },
    validateDrag (event) {
      if (event.dataTransfer.types.includes('assets')) {
        const paths = Object.keys(this.$root.$store.getters.selectedAssets)
        const accepted = paths.filter(path => {
          const module = this.$store.getters.modulesByPath[path]
          // only allow to replace with same type as original
          return this.$store.getters.type.name === module.getters.type.name
        })
        return accepted.length > 0
      }
    },
    onDrop (event) {
      // dropped assets from asset-editor
      if (event.dataTransfer.getData('assets')) {
        const assets = Object.keys(this.$root.$store.getters.selectedAssets).map(path => this.$store.getters.modulesByPath[path])
        if (assets.length > 1) {
          new Error(this.$t('only one asset error')).open()
        } else {
          this.$parent.$store.dispatch('setProp', {
            key: 'src',
            value: assets[0].getters.props.src
          })
        }
      }
    }
  },
  async mounted () {
    if (!this.$parent.ratio && this.$parent.getSize) {
      const { width, height } = await this.$parent.getSize()
      this.$parent.$store.dispatch('setProp', {
        key: 'ratio',
        value: width / height
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.file-editor {
  position: absolute;
  top: 0px;
  height: 100%;
  width: 100%;

  .remove,
  .settings,
  .move-handle {
    position: absolute;
    background: #fff;
    padding: 5px;
    border-radius: 50%;
    line-height: 1;
  }
  .remove {
    right: 70px;
    bottom: 10px;
  }
  .settings {
    right: 40px;
    bottom: 10px;

    &.locale-mode {
      right: 10px;
      bottom: 10px;
    }
  }
  .move-handle {
    right: 10px;
    bottom: 10px;
  }
  .icon {
    vertical-align: bottom;
  }
}

.asset-editor {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .asset-editor-remove,
  .asset-editor-settings {
    margin-left: 10px;
  }
}
</style>
